import { makeInteger } from '../../utils'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import './Custom.css'

// results needed if not sorting
// for sorting: inputs, sortColumnClicked, location, navigate, setResults needed
// noNumberRow is to skip the automatic numbering
export default function ColumnHeadings(props) {
  console.log('ColumnHeadings rendered: ', props)

  const { results,  noNumberRow, inputs, sortColumnClicked, location, navigate, setResults } = props
  const columnHeadings = []
  if (!noNumberRow) {
    columnHeadings.push(<th key={-1} style={{ textAlign: 'center', verticalAlign: 'bottom' }}>#</th>)
  }
  if (results && results.columnHeadings) {
    for (let i = 0; i < results.columnHeadings.length; i++) {
      let icon = ''
      if (inputs) {
        if(i + 1 === makeInteger(inputs.orderBy)) {
          let sortIcon = ''
          if (inputs.orderDir === 'ASC') {
            sortIcon = <FaCaretDown id={i+1} style={{fontSize: 'large'}} />
          } else {
            sortIcon = <FaCaretUp id={i+1} style={{fontSize: 'large'}} />
          }
          icon = sortIcon
        }
        columnHeadings.push(<th key={i} id={i + 1} className="custom-sort-column" onClick={(e) => sortColumnClicked(e, location, navigate, setResults)}>{results.columnHeadings[i]} {icon}</th>)
      }
      else {
        columnHeadings.push(<th key={i} id={i + 1} style={{ textAlign: 'center', verticalAlign: 'bottom' }}>{results.columnHeadings[i]}</th>)
      }
    }
  }
  return <tr key = {-2}>{columnHeadings}</tr>
}